import { COLORS } from "../../consts";
import styled, { css } from "styled-components";

export const Wrap = styled.div`
  display: inline-flex;
  background: ${COLORS.BG.SURFACE2};
  padding: 4px;
  border-radius: 14px;
  gap: 6px;
  width: fit-content;
`;

export const SegButton = styled.button<{ $active?: boolean }>`
  appearance: none;
  border: 0;
  cursor: pointer;
  padding: 8px 14px;
  border-radius: 10px;
  font-size: 14px;
  color: ${COLORS.FG.DEFAULT};

  transition:
    background 0.15s ease,
    box-shadow 0.15s ease;

  ${({ $active }) =>
    $active &&
    css`
      background: ${COLORS.BG.SURFACE3};
    `}
`;
